<template>

  <svg
    t="1629565933736"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5091"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="64"
    height="64"
  ><path d="M543.68 288.64h320v64h-320zM320 512h384v64H320z" p-id="5092" /><path d="M543.04 107.2h64v245.44h-64zM320 672h384v64H320z" p-id="5093" /><path d="M608 128l192 192v576H224V128z m45.12-45.12L634.56 64H160v896h704V288" p-id="5094" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconDocument',
} as DefineComponent
</script>